import { createUnifiedTheme, palettes, genPageTheme, shapes } from '@backstage/theme';

// Brand colors pulled from zubale.com's own stylesheet: #0043fc is their
// accent/CTA color, #000859 is the dark navy used for section backgrounds.
const ZUBALE_BLUE = '#0043fc';
const ZUBALE_NAVY = '#000859';

// #0043fc is tuned for light backgrounds -- against the dark theme's
// background/paper (#333/#424242) it fails WCAG contrast (~1.5:1) for
// links and text buttons, which both derive their color from
// palette.primary.main. This is the same hue lightened until it clears
// 4.5:1 on both surfaces (matches Backstage's own default dark theme,
// which likewise swaps in a lighter primary for dark mode).
const ZUBALE_BLUE_DARK_MODE = '#99B4FE';

// Replaces Backstage's default per-page-type rainbow of burst banners
// (teal for home, orange for app, purple for tools, etc.) with a single
// Zubale-colored burst used everywhere, so page headers match the brand
// instead of looking like unrelated defaults.
const zubalePageTheme = genPageTheme({
  colors: [ZUBALE_BLUE, ZUBALE_NAVY],
  shape: shapes.wave,
});
const zubalePageThemes = {
  home: zubalePageTheme,
  app: zubalePageTheme,
  documentation: zubalePageTheme,
  tool: zubalePageTheme,
  website: zubalePageTheme,
  library: zubalePageTheme,
  other: zubalePageTheme,
};

export const zubaleLightTheme = createUnifiedTheme({
  palette: {
    ...palettes.light,
    primary: { main: ZUBALE_BLUE },
    link: ZUBALE_BLUE,
    linkHover: ZUBALE_BLUE,
    navigation: {
      ...palettes.light.navigation,
      background: ZUBALE_NAVY,
      indicator: ZUBALE_BLUE,
      color: '#ffffff',
      selectedColor: '#ffffff',
    },
  },
  defaultPageTheme: 'home',
  pageTheme: zubalePageThemes,
});

export const zubaleDarkTheme = createUnifiedTheme({
  palette: {
    ...palettes.dark,
    primary: { main: ZUBALE_BLUE_DARK_MODE },
    link: ZUBALE_BLUE_DARK_MODE,
    linkHover: ZUBALE_BLUE_DARK_MODE,
    navigation: {
      ...palettes.dark.navigation,
      background: ZUBALE_NAVY,
      indicator: ZUBALE_BLUE,
      color: '#ffffff',
      selectedColor: '#ffffff',
    },
  },
  defaultPageTheme: 'home',
  pageTheme: zubalePageThemes,
});
